import { Event } from 'one-interact';
import { UserEvent } from 'one-interact-user';

import { Action } from './action'
import { Actions } from './actions'

const initial: Event = {
    type: UserEvent.LOG_OUT,
};

export const reducer = (context: any) => {
    const { log } = context;
    return (state: Event = initial, action: Action<Actions>) => {
        if(action.type === "interact-user-set")
        {
        log.debug(
            'one-state-interact-user',
            'reducer', {
                action,
            }
        );
        }
        let updated = state;
        const { type, payload } = action;
        switch (type) {
            case Actions.SET:
                updated = {
                    ...payload,
                };
                break;

            case Actions.RESET:
                updated = initial;
                break;
        }
        return updated;
    }
}
